import { useCallback, useContext } from 'react';
import { useCaptcha } from './useCaptcha';
import { CaptchaFallbackContext } from '../Contexts/CaptchaFallbackContext';

export const useCaptchaWithFallback = () => {
  const {
    captchaRef,
    captchaToken,
    loading,
    isValidCaptcha,
    handlers,
    getToken
  } = useCaptcha();

  const { requestFallbackToken } = useContext(CaptchaFallbackContext);

  const getTokenWithFallback = useCallback(
    async (timeoutMs = 10000) => {
      const invisibleToken = await getToken(timeoutMs);
      if (invisibleToken) {
        return invisibleToken;
      }
      const action = (captchaRef.current || {}).action;
      return requestFallbackToken(action);
    },
    [getToken, requestFallbackToken, captchaRef]
  );

  return {
    captchaRef,
    captchaToken,
    loading,
    isValidCaptcha,
    handlers,
    getTokenWithFallback
  };
};
